import administrationCenter from './administrationCenter';
import utilities from './utilities';

// ==============================|| MENU ITEMS ||============================== //
const menuSupervisor = {
  items: [utilities, administrationCenter],
};

export default menuSupervisor;
